var PathUtils = /** @class */ (function () {
    function PathUtils() {
    }
    PathUtils.join = function () {
        var paths = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            paths[_i] = arguments[_i];
        }
        return this.normalize(paths.filter(Boolean).join(this.separator));
    };
    PathUtils.normalize = function (path) {
        var separator = this.separator;
        var normPath = path.replace(/\/+/g, separator).replace(/(^\/+)|(\/+$)/g, '');
        var prefix = this.isAbsolute(path) ? separator : '';
        return prefix + normPath;
    };
    PathUtils.namespace = function (path) {
        var normPath = this.normalize(path);
        return normPath.split(this.separator).filter(Boolean).slice(0, -1);
    };
    PathUtils.isAbsolute = function (path) {
        return path.startsWith(this.separator);
    };
    PathUtils.separator = '/';
    return PathUtils;
}());
export { PathUtils };
export default PathUtils;
//# sourceMappingURL=path-utils.js.map